// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-d6f55dec!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Sidebar.vue
// module id = 951
// module chunks = 260